import { useCallback } from "react";

export default function usePointsConverter() {
  const percentToPixel = useCallback((points, w, h, { mutate = false } = {}) => {
    if (!points || !w || !h) return points;
    if (mutate) {
      for (const p of points) {
        p[0] = Math.round((p[0] * w) / 100);
        p[1] = Math.round((p[1] * h) / 100);
      }
      return points;
    }
    return points.map(p => [Math.round((p[0] * w) / 100), Math.round((p[1] * h) / 100)]);
  }, []);

  const pixelToPercent = useCallback((points, w, h, { mutate = false } = {}) => {
    if (!points || !w || !h) return points;
    if (mutate) {
      for (const p of points) {
        p[0] = Number.parseFloat(((p[0] * 100) / w).toFixed(2));
        p[1] = Number.parseFloat(((p[1] * 100) / h).toFixed(2));
      }
      return points;
    }
    return points.map(p => [Number.parseFloat(((p[0] * 100) / w).toFixed(2)), Number.parseFloat(((p[1] * 100) / h).toFixed(2))]);
  }, []);

  const percentToPixelConcat = useCallback((flat, w, h) => {
    if (!flat || !w || !h) return flat;
    return flat.map((v, i) => (i % 2 === 0 ? Math.round((v * w) / 100) : Math.round((v * h) / 100)));
  }, []);

  const pixelToPercentConcat = useCallback((flat, w, h) => {
    if (!flat || !w || !h) return flat;
    return flat.map((v, i) => (i % 2 === 0 ? Number.parseFloat(((v * 100) / w).toFixed(2)) : Number.parseFloat(((v * 100) / h).toFixed(2))));
  }, []);

  return {
    percentToPixel,
    pixelToPercent,
    percentToPixelConcat,
    pixelToPercentConcat,
  };
}